export enum FeaturesEnum {
  qsemLearnerShowHelpSection = 'QSEM_LEARNER_SHOW_HELP_SECTION',
  qsemLearnerShowEditProfileButton = 'QSEM_LEARNER_SHOW_EDIT_PROFILE_BUTTON',
  googleSSOEnabled = 'GOOGLE_SSO_ENABLED',
  qsLoginEnableRegisterUser = 'QS_LOGIN_ENABLE_REGISTER_USER',
  occupationsLimitedEnabled = 'QSEM_LEARNER_ENABLE_OCCUPATION_LIMIT',
  qsemAdvisorShowCareerTrendsScreen = 'QSEM_ADVISOR_SHOW_CAREER_TRENDS_SCREEN',
  qsemLearnerShowLearningPathways = 'QSEM_LEARNER_SHOW_LEARNING_PATHWAYS',
  qsDesignEnableQsInstance = 'QS_DESIGN_ENABLE_QS_INSTANCE',
  qsemAdvisorShowStudentList = 'QSEM_ADVISOR_SHOW_STUDENT_LIST',
  qsemWizardShowHobbies = 'QSEM_WIZARD_SHOW_HOBBIES',
  qsemWizardAddInstitutionQuestion = 'QSEM_WIZARD_ADD_INSTITUTION_QUESTION',
  qsemWizardTypeOfUserQuestionEnabled = 'QSEM_WIZARD_TYPE_OF_USER_QUESTION_ENABLED',
  qsemLpShowLearningPathwaysInCareerGoals = 'QSEM_LP_SHOW_LEARNING_PATHWAYS_IN_CAREER_GOALS',
  qsemAdvisorShowSkillsInsights = 'QSEM_ADVISOR_SHOW_SKILLS_INSIGHTS',
  qsemAdvisorShowStudentOverview = 'QSEM_ADVISOR_SHOW_STUDENT_OVERVIEW',
  qsemAdvisorShowStudentAdvising = 'QSEM_ADVISOR_SHOW_STUDENT_ADVISING',
  qsemAdvisorShowContactUsSection = 'QSEM_ADVISOR_SHOW_CONTACT_US_SECTION',
  qsemAdvisorShowFaqSection = 'QSEM_ADVISOR_SHOW_FAQ_SECTION',
  qsemWizardAcademicProgramEnabled = 'QSEM_WIZARD_ACADEMIC_PROGRAM_ENABLED',
  qsCounselorTextCourseInfo = 'QS_COUNSELOR_TEXT_COURSE_INFO',
  qsemDesignShowFooter = 'QSEM_DESIGN_SHOW_FOOTER',
  qsemWizardEnableCareerDiscovery = 'QSEM_WIZARD_ENABLE_CAREER_DISCOVERY',
  qsemDesignWhiteLabel = 'QSEM_DESIGN_WHITE_LABEL',
  qsemLearnerDefaultLevelOfStudy = 'QSEM_LEARNER_DEFAULT_LEVEL_OF_STUDY',
  office365SSOEnabled = 'OFFICE365_SSO_ENABLED',
  qsemSkillsShowCourseRecommendationsMessage = 'QSEM_SKILLS_SHOW_COURSE_RECOMMENDATIONS_MESSAGE',
  qsemLpProviders = 'QSEM_LP_PROVIDERS',
  qsemLpShowInfo = 'QSEM_LEARNER_SHOW_INFO_LP_SECTION',
  qsemWizardShowInfo = 'QSEM_WIZARD_SHOW_INFO',
  qsemWizardShowEmployabilityStatusQuestion = 'QSEM_WIZARD_SHOW_EMPLOYABILITY_STATUS_QUESTION',
  riipenSkillsShowValidatedSkillBadge = 'RIIPEN_SKILLS_SHOW_VALIDATED_SKILL_BADGE',
  qsemSsoSingleTenant = 'QSEM_SSO_SINGLE_TENANT',
  qsemFilterAcademicProgramsByStudentType = 'QSEM_WIZARD_CATEGORIZE_ACADEMIC_PROGRAMS',
  qsemLangDefaultLanguage = 'QSEM_LANG_DEFAULT_LANGUAGE',
  qsemLearnerCustomRedirectUrl = 'QSEM_LEARNER_CUSTOM_REDIRECT_URL',
  qsemLearnerShowJobPostingRecommendations = 'QSEM_LEARNER_SHOW_JOB_POSTING_RECOMMENDATIONS',
  qsemCustomSignupInfo = 'QSEM_CUSTOM_SIGNUP_INFO',
  qsemAutoAssignInstitutionByRegistrationCode = 'QSEM_AUTO_ASSIGN_INSTITUTION_BY_REGISTRATION_CODE',
  qsemMultiInstitutionSamlCohort = 'QSEM_MULTI_INSTITUTION_SAML_COHORT',
  qsemCoursePriceShowFilter = 'QSEM_COURSE_PRICE_SHOW_FILTER',
  qsemShowSidebarButton = 'QSEM_SHOW_SIDEBAR_BUTTON',
  qsemDesignCustomLogin = 'QSEM_DESIGN_CUSTOM_LOGIN',
  qsemContactInfoPlar = 'QSEM_CONTACT_INFO_PLAR',
  qsemShowProfileDropdown2FA = 'QSEM_SHOW_PROFILE_DROPDOWN_2FA',
  qsemEnableProficiencyLevels = 'QSEM_ENABLE_PROFICIENCY_LEVELS',
  qsemEnableProficiencyLevelsAccordions = 'QSEM_ENABLE_PROFICIENCY_LEVELS_ACCORDIONS',
  qsemLpShowLearningResourceROI = 'QSEM_LP_SHOW_LEARNING_RESOURCE_ROI',
  qsemHomepageByStudentType = 'QSEM_HOMEPAGE_BY_STUDENT_TYPE',
  qsemShowSalaryComponent = 'QSEM_SHOW_SALARY_COMPONENT',
  qsemShowOccupationComparison = 'QSEM_SHOW_OCCUPATION_COMPARISON',
  qsemMajorsEnableSpecializedMajors = 'QSEM_MAJORS_ENABLE_SPECIALIZED_MAJORS',
  qsemEnablePlar = 'QSEM_ENABLE_PLAR',
  qsemEnableAuthSaml = 'QSEM_ENABLE_AUTH_SAML',
  qsemHideCourseCompleteButton = 'QSEM_HIDE_COURSE_COMPLETE_BUTTON',
  qsemAccessCodeHide = 'QSEM_ACCESS_CODE_HIDE',
  qsemLearnerMarketInsightsInterest = 'QSEM_LEARNER_MARKET_INSIGHTS_INTEREST',
  ateneaCustomLogin = 'ATENEA_CUSTOM_LOGIN',
  qsemAlumniInsightsInsterest = 'QSEM_ALUMNI_INSIGHTS_INTEREST',
  qsemShowChatBot = 'QSEM_SHOW_CHAT_BOT',
  qsemVisualFeatures = 'QSEM_VISUAL_FEATURES',
  qsemShowCohort = 'QSEM_SHOW_COHORT',
  qsemAcademicProgramLpMapping = 'QSEM_ACADEMIC_PROGRAM_LP_MAPPING',
  qsemAlternatePlarWizard = 'QSEM_ALTERNATE_PLAR_WIZARD',
  qsemProfileAssessmentHideSkillSuggestions = 'QSEM_PROFILE_ASSESSMENT_HIDE_SKILL_SUGGESTIONS',
  qsemAcademicProgramsFacultyFilter = 'QSEM_ACADEMIC_PROGRAMS_FACULTY_FILTER',
}
